var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { Spacing } from '../theming';
import { css } from 'styled-components';
export var BASE_STYLES = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  max-width: 100%;\n"])));
export var BASE_SPACING = Spacing.Small;
export var Justification = {
  Center: 'center',
  FlexStart: 'flex-start',
  FlexEnd: 'flex-end',
  SpaceBetween: 'space-between',
  SpaceAround: 'space-around'
};
export var Alignment = {
  Center: 'center',
  FlexStart: 'flex-start',
  FlexEnd: 'flex-end',
  Baseline: 'baseline',
  Stretch: 'stretch'
};